import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faXmark
} from "@fortawesome/free-solid-svg-icons";

import "./PlansComparison.css";

const PlansComparison = ({ showFreePlan = true }) => {
  const navigate = useNavigate();
  const { user } = useAuth();

  // Alegerea planului duce la checkout-ul Stripe (date de facturare + plată);
  // prețul încasat îl stabilește serverul după `plan`, nu cel afișat aici.
  // Fără cont trecem întâi prin login: `redirect=/planlunar|/plan3luni` face ca, după
  // autentificare, pagina principală să deschidă popup-ul planului ales, care duce la checkout.
  const choosePlan = (checkoutPlan, loginRedirect) => {
    navigate(
      user
        ? `/premium/checkout?plan=${checkoutPlan}`
        : `/login?redirect=${encodeURIComponent(loginRedirect)}`
    );
  };

  const handleMonthlyPlan = () => {
    choosePlan("premium_monthly", "/planlunar");
  };

  const handleThreeMonthsPlan = () => {
    choosePlan("premium_quarterly", "/plan3luni");
  };

  return (
    <section className="plans-comparison-section">

    
{/* HEADER - afisat doar cand showFreePlan este true */}
{showFreePlan && (
  <div className="plans-comparison-header">
    <h2>Compara planurile ContaLearn</h2>
  </div>
)}


      {/* PLANURI */}
      <div
        className={`plans-comparison-grid ${
          !showFreePlan
            ? "plans-comparison-grid--premium-only"
            : ""
        }`}
      >

        {/* GRATUIT */}
        {showFreePlan && (
          <article className="comparison-plan-card comparison-free">

            <div className="comparison-plan-top">

              <h3>
                Gratuit
              </h3>

              <div className="comparison-plan-price">
                <strong>
                  0 LEI
                </strong>
              </div>

            </div>

            <div className="comparison-features">

              <div className="comparison-feature available">
                <FontAwesomeIcon icon={faCheck} />

                <span>
                  Acces la cursurile gratuite
                </span>
              </div>

                <div className="comparison-feature available">
                <FontAwesomeIcon icon={faCheck} />

                <span>
                  Toate modulele deblocate
                </span>
              </div>

              <div className="comparison-feature unavailable">
                <FontAwesomeIcon icon={faXmark} />

                <span>
                  Acces la cursurile premium
                </span>
              </div>

              <div className="comparison-feature unavailable">
                <FontAwesomeIcon icon={faXmark} />

                <span>
                 Vieti nelimitate
                </span>
              </div>

           

            </div>

            <button
              type="button"
              className="comparison-plan-button free"
              onClick={() => navigate("/quiz-start")}
            >
              Alege Gratuit
            </button>

          </article>
        )}

        {/* PREMIUM LUNAR */}
        <article className="comparison-plan-card comparison-premium">

          <div className="comparison-plan-top">

            <h3>
              Premium Lunar
            </h3>

            <div className="comparison-plan-price">
              <strong>
                39 LEI
              </strong>

              <span>
                / luna
              </span>
            </div>

          </div>

          <div className="comparison-features">

            <div className="comparison-feature available">
              <FontAwesomeIcon icon={faCheck} />

              <span>
                Acces la cursurile gratuite
              </span>
            </div>

            <div className="comparison-feature available">
              <FontAwesomeIcon icon={faCheck} />

              <span>
                Toate modulele deblocate
              </span>
            </div>

             <div className="comparison-feature available">
              <FontAwesomeIcon icon={faCheck} />

              <span>
                Acces la cursurile premium
              </span>
            </div>

            

            <div className="comparison-feature available">
              <FontAwesomeIcon icon={faCheck} />

              <span>
                Vieti nelimitate
              </span>
            </div>

            

           

         

          </div>

          <button
            type="button"
            className="comparison-plan-button premium"
            onClick={handleMonthlyPlan}
          >
            Alege Lunar
          </button>

        </article>

        {/* PREMIUM 3 LUNI */}
        <article
          className="
            comparison-plan-card
            comparison-premium
            comparison-three-months
          "
        >

          <div className="comparison-plan-top">

            <h3>
              Premium 3 Luni
            </h3>

            <div className="comparison-plan-price">
              <strong>
                99 LEI
              </strong>

              <span>
                33 lei / luna
              </span>
            </div>

        

          </div>

          <div className="comparison-features">

            <div className="comparison-feature available">
              <FontAwesomeIcon icon={faCheck} />

              <span>
                Acces la cursurile gratuite
              </span>
            </div>
            <div className="comparison-feature available">
              <FontAwesomeIcon icon={faCheck} />

              <span>
              Toate modulele deblocate
              </span>
            </div>
            <div className="comparison-feature available">
              <FontAwesomeIcon icon={faCheck} />

              <span>
                Acces la cursurile premium
              </span>
            </div>

            <div className="comparison-feature available">
              <FontAwesomeIcon icon={faCheck} />

              <span>
                Vieti nelimitate
              </span>
            </div>

           

          

           

          </div>

          <button
            type="button"
            className="comparison-plan-button premium"
            onClick={handleThreeMonthsPlan}
          >
            Alege 3 Luni
          </button>

        </article>

      </div>

    </section>
  );
};

export default PlansComparison;